import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { MfgUnit } from "@/lib/manufacturing/types";
import type { MfgUnitPhaseHistory } from "@/lib/manufacturing/buildPipelineTypes";

export type ProductionOverview = {
  plant_id: string;
  in_progress: number;
  final_qa: number;
  build_complete: number;
  total_active: number;
  by_phase: Array<{
    phase_id: string;
    phase_key: string;
    display_name: string;
    count: number;
  }>;
};

export type ManufacturingUnitDetail = {
  unit: MfgUnit;
  current_phase: {
    id: string;
    phase_key: string;
    display_name: string;
    sequence_index: number;
    is_initial: boolean;
    is_build_complete: boolean;
    is_pay_trigger: boolean;
    sub_role_tag: string;
  } | null;
  built_unit: {
    id: string;
    status: string;
    serial: string | null;
    build_started_at: string | null;
    build_completed_at: string | null;
  } | null;
  history: MfgUnitPhaseHistory[];
  plant_packet: Array<{
    item_key: string;
    label: string;
    status: string;
    evidence_url: string | null;
    notes: string;
  }>;
};

export function getManufacturingProductionOverview(plantId: string) {
  const q = new URLSearchParams({ plant_id: plantId });
  return manufacturingFetch<{ ok: true; overview: ProductionOverview }>(
    `/api/mfg/production/overview?${q.toString()}`,
    { method: "GET" },
  );
}

export function getManufacturingUnitDetail(unitId: string) {
  const q = new URLSearchParams({ unit_id: unitId });
  return manufacturingFetch<{ ok: true; detail: ManufacturingUnitDetail }>(
    `/api/mfg/units/detail?${q.toString()}`,
    { method: "GET" },
  );
}

export function shipManufacturingUnitFromPlant(payload: { unit_id: string }) {
  return manufacturingFetch<{ ok: true; unit: MfgUnit }>("/api/mfg/units/ship-from-plant", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
